import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  backend_url: 'https://api.hana-english.com'
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
